import { profileData } from '@/mocks/profile';

export default function ProfileSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100" aria-labelledby="profile-title">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm text-primary-500 font-medium tracking-widest mb-2">PERSONAL PROFILE</p>
          <h2 id="profile-title" className="font-heading text-2xl md:text-3xl text-foreground-950">个人资料</h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-[380px] shrink-0">
            <div className="w-full aspect-[3/4] overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=beautiful%20Japanese%20actress%20elegant%20portrait%20with%20warm%20natural%20lighting%2C%20soft%20cream%20background%2C%20gentle%20smile%2C%20minimalist%20fashion%20style%2C%20professional%20headshot%20photography%2C%20warm%20neutral%20tones%2C%20clean%20composition&width=600&height=800&seq=profile-portrait&orientation=portrait"
                alt="佐佐木明希 个人写真"
                className="w-full h-full object-cover object-top"
                title="佐佐木明希个人资料写真"
              />
            </div>
          </div>

          <div className="flex-1">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-6 mb-8">
              {[
                { label: '本名', value: profileData.nameJa },
                { label: '生日', value: profileData.birthday },
                { label: '出生地', value: profileData.birthplace },
                { label: '身高', value: profileData.height },
                { label: '血型', value: profileData.bloodType },
                { label: '出道', value: profileData.debut },
                { label: '事务所', value: profileData.agency },
                { label: '特长', value: profileData.specialty },
              ].map((item) => (
                <div key={item.label} className="bg-background-50 rounded-lg p-4">
                  <p className="text-xs text-foreground-400 mb-1">{item.label}</p>
                  <p className="text-sm font-medium text-foreground-900">{item.value}</p>
                </div>
              ))}
            </div>

            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              {profileData.bio}
            </p>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-3">主要荣誉</h4>
              <ul className="space-y-2">
                {profileData.achievements.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm text-foreground-600">
                    <i className="ri-medal-line text-accent-500 mt-0.5 shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}